import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.scss']
})
export class MasterListComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public CurrentUrl:any=this.router.url;
  public Ids:any='';
  public reasons:any='';
  public statuskey:any='';

  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");  
    if(this.CurrentUrl =='/interest'){
      this.getDetail(this.p);
    } else {
      this.getDetail1(this.p);
    }
   }

  ngOnInit(): void {
  }

     getDetail(page:any){
      this.loading=true;
      var url='master/interest-list?page='+page;       
      if(this.searchKey!=''){
        url=url+'&search='+this.searchKey;
      }
      if(this.statuskey!=''){
        url=url+'&status='+this.statuskey;
      }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this; 
          response.data.filter((el:any)=>{
            if(el.icon ==''){
              el.icon =self.service.defaultImage;
            }
          }) 
          self.dataListing=response.data ;
          self.totalCount = response.totalCounts;  
          this.loading=false;
        } else {
          this.dataListing=[];
          this.totalCount = response.totalCounts;  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    getDetail1(page:any){
      this.loading=true;
      var url:any="";  
      if(this.CurrentUrl=='/eye-type'){
        url='master/eye-type-list?page='+page;
      } 
      if(this.CurrentUrl=='/hair-type'){
        url='master/hair-type-list?page='+page;  
      }
      if(this.CurrentUrl=='/body-type'){
        url='master/body-type-list?page='+page;  
      } if(this.CurrentUrl=='/langugae'){
        url='master/language-list?page='+page; 
      } if(this.CurrentUrl=='/prefrence'){
        url='master/preference-list?page='+page; 
      }
      
      if(this.searchKey!=''){
        url=url+'&search='+this.searchKey;
      }
      if(this.statuskey!=''){
        url=url+'&status='+this.statuskey;
      }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this; 
          self.dataListing=response.data ;
          self.totalCount = response.totalCounts;  
          this.loading=false;
        } else {
          this.dataListing=[];
          this.totalCount = response.totalCounts;  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }
   
    redirect(item:any,type:any){
      this.Ids =item._id;
      localStorage.setItem('hva_content',JSON.stringify(item));
     if (type ==3){
        if(this.CurrentUrl =='/interest'){
          this.router.navigate(['/update-interest']);
        } else if(this.CurrentUrl=='/eye-type'){
          this.router.navigate(['/update-eye-type']);
        } else if(this.CurrentUrl=='/hair-type'){
          this.router.navigate(['/update-hair-type']); 
        } else if(this.CurrentUrl=='/body-type'){
          this.router.navigate(['/update-body-type']);
        } else if(this.CurrentUrl=='/langugae'){
          this.router.navigate(['/update-langugae']); 
        } else if(this.CurrentUrl=='/prefrence'){
          this.router.navigate(['/update-prefrence']);
        }  
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then((result:any) => {
          let statusType: number = 0;
          if (result.isConfirmed) {
            this.delete();
            // $('#text3').trigger('click');
          }
        });
      }
    }
  
    delete(){     
      var url="";
      if(this.CurrentUrl=='/interest'){
        url='master/delete-interest/'+ this.Ids; 
      } else if(this.CurrentUrl=='/eye-type'){
        url='master/delete-eye-type/'+ this.Ids; 
      } else if(this.CurrentUrl=='/hair-type'){
        url='master/delete-hair-type/'+ this.Ids;  
      } else if(this.CurrentUrl=='/body-type'){
        url='master/delete-body-type/'+ this.Ids; 
      } else if(this.CurrentUrl=='/langugae'){
        url='master/delete-language/'+ this.Ids; 
      } else if(this.CurrentUrl=='/prefrence'){
        url='master/delete-preference/'+ this.Ids; 
      }  
        this.service.updateApi1({},url).subscribe(((response:any)=>{
          if(response.success==1) {  
            this.loading=false;
            this.p=1;
            if(this.CurrentUrl=='/interest'){
            this.getDetail(this.p);
            } else {
              this.getDetail1(this.p);
            }
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
      // }
    }

    verifyAccount(item:any,status:any){
      // var url='/verify-account/'+item;
      // this.service.updateApi1({"status":status},url).subscribe(((response:any)=>{
      //   if(response.success==1){
      //     this.service.successAlert(response.message);
      //     this.getDetail(1);
      //   } else {
      //     this.service.dangerAlert(response.message);
      //   }
      // }))
    }

    reset(){
      this.p=1;
      this.pageLimit=10;
      this.searchKey='';
      this.statuskey="";
      this.getdata(this.p);
    }

    getdata(p:any){
      if(this.CurrentUrl =='/interest'){
        this.getDetail(this.p);
      } else {
        this.getDetail1(this.p);
      }
    }


}
